import Model from '../model.js';

export default class Lookup extends Model
{
    constructor(id, name, title, created_at = null, updated_at = null) {
        super()
        this.id         = id ?? 0
        this.name       = name
        this.title      = title
        this.created_at = created_at??null
        this.updated_at = updated_at??null
        this.init()
    }
    toList() {
        return {
            value: this.id,
            label: this.name,
        }
    }
}

